<template>
  <v-container class="acc-gym-subscription-detail" fluid v-if="subscription">
    <v-row>
      <v-col cols="4" lg="2">
        <font-awesome-icon icon="chevron-circle-left" @click="$router.back()"></font-awesome-icon>
      </v-col>
      <v-col cols="8" lg="10" class="title-label">
        <label v-html="$t('gym_subscription.title')"></label>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field readonly
                      :label="$t('gym_subscription.account')"
                      :value="`${subscription.account.given_name}, ${subscription.account.surname}`"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field readonly
                      :label="$t('gym_subscription.type')"
                      :value="subscription.type.name"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field readonly
                      :label="$t('gym_subscription.status')"
                      :value="subscriptionStatus"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field readonly
                      :label="$t('gym_subscription.valid_until')"
                      :value="$parseDate(subscription.valid_until, 'yyyy-MM-dd')"></v-text-field>
      </v-col>
    </v-row>

    <GymSubscriptionCheckInRecordList :subscription-id="subscriptionId"
                                      is-admin></GymSubscriptionCheckInRecordList>


  </v-container>
</template>

<script>
import {computed, onMounted, ref} from '@vue/composition-api'
import {BOOKING_STATUS_LABEL} from "@/constants";
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";

export default {
  name: 'AccGymSubscriptionDetail',
  components: {GymSubscriptionCheckInRecordList},
  setup(props, {root}) {
    const subscriptionId = ref(root.$route.params.subscriptionId);
    const subscription = ref(null);
    const subscriptionStatus = computed(() => {
      return subscription.value ? root.$t(BOOKING_STATUS_LABEL[subscription.value.status]) : '';
    })

    const getSubscription = function () {
      root.$callAPI('aafb/admin/gym_subscription/', {
        subscription_id: root.$route.params.subscriptionId,
        from_date: props.fromDate,
        to_date: props.toDate,
      }, function (response) {
        subscription.value = response.body.subscription;
      });
    };
    const showCheckInRecords = ref(true);
    const checkIn = function () {
      root.$callAPI('aafb/admin/gym_subscription/checkin/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
        showCheckInRecords.value = false;
        setTimeout(() => {
          showCheckInRecords.value = true;
        }, 50);
      });
    };
    const checkOut = function () {
      root.$callAPI('aafb/admin/gym_subscription/checkout/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
        showCheckInRecords.value = false;
        setTimeout(() => {
          showCheckInRecords.value = true;
        }, 50);
      });
    };

    onMounted(() => {
      getSubscription();
    });

    return {
      subscriptionId,
      subscription,
      subscriptionStatus,
      showCheckInRecords,
      checkIn,
      checkOut
    }
  },
}
</script>

<style lang="less">
.acc-gym-subscription-detail {
  .fa-chevron-circle-left {
    font-size: 3em;
    cursor: pointer;
  }

  .title-label {
    text-align: left;
    line-height: 1.5em;
    font-size: 2em;
  }
}
</style>
